import { compose } from 'redux'

import withErrorBoundary from 'components/shared/withErrorBoundary'
import withQueryResults from 'components/shared/withQueryResults'
import withParams from './withParams'
import withRedux from './withRedux'
import withQuery from './withQuery'
import withFormResults from 'components/shared/withFormResults'
import withMutation from './withMutation'
import withEventHandlers from './withEventHandlers'

// presentational components
import UI from './UI'

const withEditCamperForm = options => {
  const { redirect } = options

  const withEditCamperFormResults = withFormResults({
    mutation: 'updateCamper',
    field: 'camper',
    successMessage: 'Camper updated',
    redirect
  })

  return compose(
    withParams, // for camperId
    withErrorBoundary,
    withRedux,
    withQueryResults,
    withEditCamperFormResults,
    withQuery,
    withMutation,
    withEventHandlers
  )
}

// for account flow
export default withEditCamperForm({ redirect: '/' })(UI)

// for registration flow
export { withEditCamperForm }
